let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fqgt6")).then(() => parcelRequire('ik6DH'));